// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1055":"cce92c22","3532":"ff5c60ea","4573":"cce92c22","7895":"f82760f3","7900":"7796e402","8885":"863eda24"}[chunkId] + ".chunk.css";
};